<template>
  <div class="container-fluid mt-5 report">
    <div class="d-flex align-items-end justify-content-between">
      <div class="d-flex align-items-end">
        <img :src="getFiles(userData.logo)" alt="Company Logo" class="logo" width="70px">
        <div class="mx-3">
          <div class="h3 text-primary"> <b>{{ userData.business }} </b> </div>
          <span class="h6"> <i class="fas fa-map-marker-alt"></i> {{ userData.location }} </span>
          <span class="h6"> | <i class="fas fa-phone-alt"></i> {{ userData.contact }} </span>
        </div>
      </div>
      <div>
        <span class="text-primary">Date: <b>{{ new Date().toLocaleDateString('en-US', options) }}</b></span>
      </div>
    </div>
    <hr>
    <div class="report-title">
      <h2>Checkoff List: <b>{{ period }}</b></h2>
    </div>
    <div class="report-body">
      <table class="table table-striped" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr class="align-middle">
            <th>#</th>
            <th>Member</th>
            <th>Saving</th>
            <th>Loan</th>
            <th>COFU</th>
            <th>Subscription</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in checkoff_list_items" :key="index" class="align-middle">
            <td>{{ index + 1 }}</td>

            <td>
              <span>
                <span>{{ item.member.name }}</span>
                <span class="d-block text-info fw-bold">{{ item.member.member_id }}</span>
              </span>
            </td>

            <td>
              <span>{{ commas(item.saving) }}</span>
            </td>

            <td>
              <span>{{ commas(item.loan) }}</span>
            </td>

            <td>
              <span>{{ commas(item.cofu) }}</span>
            </td>

            <td>
              <span>{{ commas(item.subscription) }}</span>
            </td>

            <td class="fw-bold">{{ commas((item.saving + item.loan + item.cofu + item.subscription) || '-')
              }}</td>

          </tr>
        </tbody>

        <tfoot style="position: sticky; bottom: 0; background-color: white; z-index: 1;">
          <tr class="fw-bold">
            <td>#</td>
            <td>Total</td>
            <td>{{ commas(checkoff_list_items.reduce((total, item) => total + (item.saving || 0), 0)) }}
            </td>
            <td>{{ commas(checkoff_list_items.reduce((total, item) => total + (item.loan || 0), 0)) }}</td>
            <td>{{ commas(checkoff_list_items.reduce((total, item) => total + (item.cofu || 0), 0)) }}</td>
            <td>{{ commas(checkoff_list_items.reduce((total, item) => total + (item.subscription || 0), 0))
              }}</td>
            <td class="fs-5 text-primary fw-bold">{{ commas(checkoff_list_items.reduce((total, item) =>
              total +
              (item.saving
                + item.loan + item.cofu + item.subscription || 0), 0)) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="footer text-end me-3" style="background-color: transparent;">
      <i>Generated by <b>{{ userData.username }}</b> on <b> {{ new Date().toLocaleDateString('en-US', options)
          }}</b></i>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      options: { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" },
      id: '',
      amount_paid: 0,
      date_of_payment: "",
      mode_of_payment: "",
      reference: '',
      checkoff_list_items: [],
      period: ''
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo() {
      this.id = this.$route.query.id;
      this.period = `${this.$route.query.month} - ${this.$route.query.year}`
      await axios.get(`/checkoff-list/${this.id}`).then((response) => {
        if (response.status == 200) {
          this.checkoff_list_items = response.data.checkoff_list_items;
          this.checkoff_list_loader = false;
        }
        setTimeout(() => {
          document.title = `Checkoff List ${this.period}`;
          window.print();
          window.onafterprint = this.$router.go(-1);
        }, 2000);
      });
    },
  },
};
</script>
